@import "../../styles/colors";

.GenericBanner {
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-100px);
  overflow: hidden;
  transition: all 0.5s;
  opacity: 0;

  &.visible {
    transform: translateY(0);
    opacity: 1;
  }

  .banner-content {
    box-sizing: border-box;
    padding: 20px;
    background: $mixtiles-pink3;
    background-size: cover;
    position: relative;
    max-width: 800px;
    width: 100%;
    height: 96px;
    border-radius: 4px;
    margin: 16px;

    .text {
      position: relative;
      float: left;
      color: $fontWhite;
      z-index: 1;

      .title {
        font-size: 22px;
        font-weight: 700;
        line-height: 1.7;
      }

      .subtitle {
        font-size: 16px;
      }
    }

    .countdown-wrapper {
      position: relative;
      z-index: 1;
      float: right;
      width: auto;
      margin: 5px 0 0 0;

      .countdown {
        width: auto;
        margin: 0;

        .flip {
          width: 28px;
          height: 33px;
          padding: 0;
          box-shadow: none !important;
          float: none;
          display: inline-block;
          margin: 1px;

          * {
            font-size: 22px !important;
            line-height: 36px !important;
            outline: 0 !important;
          }

          .flip-clock-active {
            .down {
              box-shadow: 0 1px 2px 1px #ff0072;
            }
          }

          .inn {
            background-color: #fff !important;
            color: $mixtiles-light-black !important;
            text-shadow: none;
          }
        }

        .flip-clock-divider {
          height: 20px;
          float: none;

          * {
            display: none;
          }
        }
      }

      .tooltip {
        margin-top: 2px;
        display: flex;
        justify-content: space-between;
        font-size: 11px;
        color: #fff;
        font-weight: 700;

        .tt-content {
          flex-basis: 61px;
          text-align: center;
        }

        .tt-divider {
          flex-basis: 20px;
        }
      }
    }

    @media (max-width: 768px) {
      height: auto;
      margin: 0;
      border-radius: 0;
      padding: 15px 5px;
      .text {
        float: none;
        text-align: center;
      }
      .countdown-wrapper {
        float: none;
        margin-top: 20px;
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
        white-space: nowrap;
      }
    }
  }
}